import Swal from "sweetalert2"
import { navigateToIndex, navigateToCheckPoint, navigateToPetLoss } from "../common/function"
import * as API from "../services/httpService"
import { updateUiData } from "../redux/actions"
import * as Constants from "../common/constants"

// import withReactContent from "sweetalert2-react-content"

// const MySwal = withReactContent(Swal)

export function missingInfoAlert() {
  Swal.fire({
    icon: "error",
    title: "Oops...",
    text:
      "Some information that is provided is not correct. Please check again. Thank you.",
  })
}

export function waitingPeriodValidation() {
  Swal.fire({
    icon: "error",
    title: "Oops...",
    text:
      "Your claim falls within the policy’s waiting period and is not eligible for coverage. Please refer to your policy terms or contact us for assistance.",
  })
}

export function deductibleAmountValidation() {
  Swal.fire({
    icon: "error",
    title: "Oops...",
    text:
      "Your claim cannot be processed because the total claim amount is less than the deductible.",
  })
}

export function policyValidationAlert() {
  Swal.fire({
    icon: "error",
    title: "Oops...",
    text:
      "Some information provided is not correct.  Please check again.  Thank you.",
  })
}

export function backendDownNotice() {
  Swal.fire({
    icon: "warning",
    title: "Oops...",
    html:
      "Sorry, we're down for scheduled maintenance. <br />We should be back online shortly. <br />Please try again later.",
  })
}

export function missingProvideDocumentProofOfClaimAlert() {
  Swal.fire({
    icon: "error",
    title: "Oops...",
    text: "Please provide document for proof of claim. Thank you.",
  })
}

export function pleaseAgreeAlert() {
  Swal.fire({
    icon: "error",
    title: "Oops...",
    text: "Please agree with the Terms & Conditions to proceed. Thank you.",
  })
}

export function fillPolicyDetailAlert() {
  Swal.fire({
    icon: "error",
    title: "Oops...",
    text:
      "Please fill in all the information for Policy. Please check again. Thank you.",
  })
}

export function invalidCommenceDateAlert() {
  Swal.fire({
    icon: "error",
    title: "Oops...",
    text:
      "Please enter valid Policy Commencement Date. Please check again. Thank you.",
  })
}

export function fillDependantsDetailAlert() {
  Swal.fire({
    icon: "error",
    title: "Oops...",
    text:
      "Please fill in all the information for Dependants. Please check again. Thank you.",
  })
}

export function pleaseAddDependantsBeforeNext() {
  Swal.fire({
    icon: "warning",
    title: "Notice",
    text:
      "Please click add button to save Dependants details before going to next page. Thank you.",
  })
}

export function fillEarningDetailAlert() {
  Swal.fire({
    icon: "error",
    title: "Oops...",
    text:
      "Please fill in all the information for Earning. Please check again. Thank you.",
  })
}

export function pleaseAddEarningBeforeNext() {
  Swal.fire({
    icon: "warning",
    title: "Notice",
    text:
      "Please click add button to save Earning details before going to next page. Thank you.",
  })
}

export function largeUploadedFile() {
  Swal.fire({
    icon: "warning",
    title: "Notice",
    text:
      "Large file size is detected, we will automatically compress the file, and this may take a few minutes to complete. We appreciate your patience.",
  })
}

export function errorWhenUpload() {
  Swal.fire({
    icon: "warning",
    title: "Notice",
    text:
      "Error while processing, kindly delete and reupload the file. Thank you.",
  })
}

export function insuredValidationAlert() {
  Swal.fire({
    icon: "error",
    title: "Oops...",
    text:
      "The Deceased details does not match our records. Please check again. Thank you.",
  })
}

export function missingSelectNatureOrOccurAlert() {
  Swal.fire({
    icon: "error",
    title: "Oops...",
    text: "Please select type of claim. Thank you.",
  })
}

export function commonErrorAlert(message) {
  Swal.fire({
    icon: "error",
    title: "Oops...",
    text: message,
  })
}

export function commonWarningAlert(message) {
  Swal.fire({
    icon: "warning",
    title: "Notice",
    text: message,
  })
}

const ClearDataWarning = Swal.mixin({
  customClass: {
    confirmButton: "swal-button--back",
    cancelButton: "swal-button--next",
    actions: "swal-footer",
  },
  buttonsStyling: false,
})

export function clearAllDataWarning(
  claimUploadListModel,
  folderName,
  dispatch
) {
  ClearDataWarning.fire({
    title:
      "Are you sure you want to go back to the previous page? This will be remove all the data you have entered.",
    //icon: "warning",
    scrollbarPadding: false,
    showCancelButton: true,
    confirmButtonColor: "#ff3333",
    cancelButtonColor: "#fff",
    confirmButtonText: "Yes",
    cancelButtonText: "No",
    focusConfirm: false,
  }).then(result => {
    if (result.value) {
      clearAllData(
        claimUploadListModel,
        folderName,
        dispatch
      );

      navigateToPetLoss()
    }
    return false
  })
}

export function clearAllData(
  claimUploadListModel,
  folderName,
  dispatch
) {
    let deleteMultipleFileArray = []

    claimUploadListModel.forEach((UploadedItem, UploadedKey) => {
      let deleteFileInfo = {}
      deleteFileInfo.fName = UploadedItem.fileName
      deleteFileInfo.folderName = folderName
      deleteMultipleFileArray.push(deleteFileInfo)
    })

    API.apiPostRequest(
      "/Claim/ClaimDocsMultipleDelete",
      deleteMultipleFileArray,
      null
    ).then(response => {
      dispatch(updateUiData("claimUploadListModel", []))
    })
}

export function changeClaimTypeWarning(
  claimUploadListModel,
  folderName,
  dispatch,
  form,
  buttonName,
  buttonValue,
  setForceRefresh
) {
  ClearDataWarning.fire({
    title:
      "You are about to change claim type. Uploaded document will be removed. Are you sure you want to continue?",
    //icon: "warning",
    scrollbarPadding: false,
    showCancelButton: true,
    confirmButtonColor: "#ff3333",
    cancelButtonColor: "#fff",
    confirmButtonText: "Yes",
    cancelButtonText: "No",
    focusConfirm: false,
  }).then(result => {
    if (result.value) {
      form.setFieldValue(buttonName, buttonValue)

      dispatch(updateUiData("showLoading", true))

      let deleteMultipleFileArray = []
      claimUploadListModel.forEach((UploadedItem, UploadedKey) => {
        let deleteFileInfo = {}
        deleteFileInfo.fName = UploadedItem.fileName
        deleteFileInfo.folderName = folderName
        deleteMultipleFileArray.push(deleteFileInfo)
      })

      API.apiPostRequest(
        "/Claim/ClaimDocsMultipleDelete",
        deleteMultipleFileArray,
        null
      ).then(response => {
        dispatch(updateUiData("claimUploadListModel", []))

        // navigateToIndex()
        navigateToCheckPoint()
      })
    }

    return result.value
  })
}

const RemoveBenefitWarning = Swal.mixin({
  customClass: {
    confirmButton: "swal-button--yes",
    cancelButton: "swal-button--no",
    actions: "swal-footer",
  },
  buttonsStyling: false,
})

export function removeBenefitPopUp(
  dispatch,
  claimUploadListModel,
  folderName,
  removeFileFromList,
  updateClaimData,
  selectedBenefitsDetail,
  benefitRemove,
) {
  RemoveBenefitWarning.fire({
    title: "Do you want to remove this claim?",
    icon: "warning",
    scrollbarPadding: false,
    showCancelButton: true,
    confirmButtonColor: "#ff3333",
    cancelButtonColor: "#fff",
    confirmButtonText: "Yes, I do",
    cancelButtonText: "No, I don’t",
    focusConfirm: false,
  }).then(result => {
    if (result.value) {
      // setEditBenefitsCoverage(null) //Hide the edit form row
      
      //remove benefit from selected list
      let tempSelectedBenefit = selectedBenefitsDetail
      tempSelectedBenefit.splice(tempSelectedBenefit.indexOf(selectedBenefitsDetail.find(e => e["claimType"] == benefitRemove)),1)
      dispatch(updateClaimData("selectedBenefitsDetail", tempSelectedBenefit))
      
      //remove docList
      let removeDocIds = [];
      switch(benefitRemove){
        case "Illness": removeDocIds = Constants.removeIllnessDocs; break
        case "Accident": removeDocIds = Constants.removeAccidentDoc; break
        case "Funeral Expenses": removeDocIds = Constants.removeFuneralDocs; break
        case "Third Party Liability Claim": removeDocIds = Constants.removeThirdpartDocs; break
        default: break
      }
      let thisCoverageUploadedList = claimUploadListModel.filter(doc => removeDocIds.includes(doc.documentId))

      let deleteMultipleFileArray = []

      thisCoverageUploadedList.forEach((UploadedItem, UploadedKey) => {
        let deleteFileInfo = {}
        deleteFileInfo.fName = UploadedItem.fileName
        deleteFileInfo.folderName = folderName
        deleteMultipleFileArray.push(deleteFileInfo)

        dispatch(
          removeFileFromList(UploadedItem.fileName, UploadedItem.fileSize)
        )
      })
      

      API.apiPostRequest(
        "/Claim/ClaimDocsMultipleDelete",
        deleteMultipleFileArray,
        null
      ).then(response => {})
    }
    return false
  })
}
